<template lang="pug">
#text-document-tab
  div(v-if="haveTextFields")
    ul.nav.nav-tabs#nav-text-fields(role="tablist")
      li.nav-item(v-for="field in text_fields")
        a(
          :id="field.id"
          :class="tabClass(field)"
          :data-target="fieldTarget(field)"
          :aria-controls="field.id"
          @click="selectTab(field)"
        ) {{ field.label }}
    .tab-content#content-text-fields
      div(v-for="field in text_fields" :class="contentClass(field)" :id="field.id")
        div(v-html="fieldText(field.value)")
</template>

<script>
import Vue from 'vue'

export default {
  name: "documents-document-texts-vue",
  props: {
    text_fields: { type: Array, default: () => [] },
  },
  data() {
    return {
      bus: new Vue(),
      currentSelectedField: false,
    };
  },
  computed: {
  },
  methods: {
    haveTextFields(){
      return this.text_fields.length > 0
    },
    fieldTarget(field) {
      return "#"+field.id
    },
    fieldTab(field) {
      return field.id+"-tab"
    },
    fieldText(text_array) {
      return text_array.join("<br>")
    },
    selectTab(field) {
      if (field.id == this.currentSelectedField) {
        this.currentSelectedField = false
        return
      }
      this.currentSelectedField = field.id
    },
    tabClass(field) {
      return this.currentSelectedField == field.id ? "nav-link active" : "nav-link"
    },
    contentClass(field) {
      return this.currentSelectedField == field.id ? "tab-pane fade show active" : "tab-pane fade"
    }
  },
  mounted() {
  },
  beforeDestroy() {
  }
};
</script>
